import { render } from "./ProductVideoListComponent.vue?vue&type=template&id=0677da02"
import script from "./ProductVideoListComponent.vue?vue&type=script&lang=js"
export * from "./ProductVideoListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/video/ProductVideoListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0677da02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0677da02', __exports__)) {
    api.reload('0677da02', __exports__)
  }
  
  module.hot.accept("./ProductVideoListComponent.vue?vue&type=template&id=0677da02", () => {
    api.rerender('0677da02', render)
  })

}


export default __exports__